import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import SearchBar from '../../../components/utils/SearchBar'
import Table from '../../../components/utils/Table'
import { useDispatch, useSelector } from 'react-redux';
import { convertDateToRequiredFormatTZ } from '../../../helpers/commonFunction'
import LockedActivationActions from "../../../redux/lockedActivation/actions"
import Alert from '../../../components/utils/Alert';
import useSocket from '../../../hooks/useSocket';
import SocketActions from '../../../redux/socket/actions';
import { isAdmin, isAdminAgent } from '../../../helpers/commonFunction';

const { getLockedSIMSwapRequest, releaseSIMSwapRequest, resetMessage } = LockedActivationActions
const { getLockedSIMSwapRequestForSocket } = SocketActions;

const ActivationRequest = () => {
    const dispatch = useDispatch();
    const [filterText, setFilterText] = useState("");
    const { tokenData } = useSelector((state) => state.auth);
    const { lockedSimSwapResult, realselockSIMSwapmessage, realselockSIMSwaperror, loading } = useSelector((state) => state.lockedActivation);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [releaselockloading, setReleaseLockLoading] = useState(null);

    useSocket('SIM Swap Request Pending updated', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getLockedSIMSwapRequestForSocket());
        }
    });

    useEffect(() => {
        dispatch(getLockedSIMSwapRequest());
    }, [])

    useEffect(() => {
        if (realselockSIMSwapmessage !== null && realselockSIMSwapmessage !== undefined) {
            displayAlert(realselockSIMSwapmessage, 'alert-success');
        }
        if (realselockSIMSwaperror !== null && realselockSIMSwaperror !== undefined) {
            displayAlert(realselockSIMSwaperror, 'alert-danger');
            setReleaseLockLoading(null)
        }
    }, [realselockSIMSwapmessage, realselockSIMSwaperror]);

    const handleFilterChange = (value) => {
        setFilterText(value);
    };
    const handleUnLockActivation = (simswapID) => {
        setReleaseLockLoading(simswapID);
        let data = {
            simswapID: simswapID
        }
        dispatch(releaseSIMSwapRequest(data));
    }

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
    }

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        dispatch(resetMessage());
    };


    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'TRANSACTION ID', key: 'transactionID' },
        { displayName: 'SERIAL NUMBER', key: 'serialNumber' },
        { displayName: 'LOCKED DATE', key: 'createdDate' },
        { displayName: 'LOCKED BY', key: 'lockedBy' },
        { displayName: 'ACTION', key: 'action' },
    ];

    const filteredItems = Array.isArray(lockedSimSwapResult) && lockedSimSwapResult.length > 0 ? lockedSimSwapResult.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];

    var dataSource = filteredItems && filteredItems.length > 0 && filteredItems.map((item, key) => {
        return {
            key: key + 1,
            transactionID: item.TransactionID,
            serialNumber: item.SerialNumber,
            lockedBy: item.LockedBy,
            createdDate: convertDateToRequiredFormatTZ(item.CreatedDate),
            action: (
                releaselockloading === item.SimSwapID ? (<div className="spinner-border text-secondary" role="status"> <span className="sr-only">Loading...</span> </div>) : (
                    <div className="icon iq-action-icon-box rounded-circle bg-secondary" onClick={() => handleUnLockActivation(item.SimSwapID)} style={{ cursor: 'pointer' }} >
                        <i className="ri-lock-unlock-line"></i>
                    </div>
                )
            )
        }
    });

    return (
        <>
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <div className="col-md-3">
                <SearchBar onFilter={handleFilterChange} filterText={filterText} />
            </div>

            <Table columns={columns} loading={loading} data={dataSource} pagination={true} />
        </>
    )
}

export default ActivationRequest
